import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { getAllItemsData } from "../../Utility/Api";
import { endPoints, Image_Url } from "../../Constant/Environment";
import { getFullUrl } from "../../Constant/makeApiCall";
import MetaTags from '../MetaTags';
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { InfinitySpin } from 'react-loader-spinner'
import Loader from '../Loader';


function Work() {
  const dispatch = useDispatch();
  // const { workPageData } = useSelector((state) => state.howItWorksPageData);
  const [isLoading, setIsLoading] = useState(false);
  const [workPageData, setWorkPageData] = useState({});

  const getWorkPageData = () => {
    let url = `${endPoints.api.HOWITWORKS_DATA}`;
    setIsLoading(true);

    getAllItemsData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          setWorkPageData(data);
          setIsLoading(false);
          // dispatch({
          //   type: Actions.FETCH_HOWITWORK_PAGE_DATA_SUCCESS,
          //   data: {
          //     workPageData: data,
          //   },
          // });
        } else {
          // Handle error or show a message
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // if (workPageData.length == 0) {
    // }
    getWorkPageData();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      {isLoading ? (
        // <Loader spinner={true} visible={isLoading} className="loader" />
        <div className="page_loader"><InfinitySpin
          visible={true}
          width="200"
          color="#4fa94d"
          ariaLabel="infinity-spin-loading"
        /></div>
      ) : (
        <>
          <MetaTags
            title={workPageData && workPageData.meta_title}
            description={workPageData && workPageData.meta_descriptions}
            image={Image_Url + workPageData.banner}
            canonicalUrl={getFullUrl()}
          />
          <div className="banner-inner">
            {workPageData && workPageData.banner ? (

              <img
                src={Image_Url + workPageData.banner}
                alt="logo1"
              // loading="lazy"
              />
            ) : null}
            <div className="banner-text">
              <h3 className="c-heading">{workPageData && workPageData.banner_title}</h3>
              <p>{workPageData && workPageData.banner_descriptions}</p>
            </div>
          </div>

          <main className="middle contact-page">
            <section className="pt-3">
              <div className="container">
                <Breadcrumb>
                  <Breadcrumb.Item>Welcome</Breadcrumb.Item>
                  <Breadcrumb.Item active>HOW IT WORKS</Breadcrumb.Item>
                </Breadcrumb>
                <h2 className="c-heading sec-padd-t text-center">
                  {workPageData && workPageData.banner_descriptions}
                </h2>
                <Row className="g-5 pt-5 sec-padd-b">
                  <Col md={4}>
                    <div className="work-box">
                      <img
                        src={require("../../Assets/Images/home-img02.webp")}
                        alt="logo2"
                      />
                      <h4>
                        {workPageData && workPageData.first_title}
                      </h4>
                      <p>
                        {workPageData && workPageData.first_descriptions}
                      </p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="work-box">
                      <img
                        src={require("../../Assets/Images/home-img03.webp")}
                        alt="logo2"
                      />
                      <h4>
                        {workPageData && workPageData.second_title}
                      </h4>
                      <p>
                        {workPageData && workPageData.second_descriptions}
                      </p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="work-box">
                      <img
                        src={require("../../Assets/Images/home-img01.webp")}
                        alt="logo2"
                      />
                      <h4> {workPageData && workPageData.third_title}</h4>
                      <p>
                        {workPageData && workPageData.third_descriptions}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>
            <section className="sec-padd work-banner">
              <div className="container">
                <Row className="work-box rounded-0 border-0">
                  <Tabs
                    defaultActiveKey="first"
                    className="align-items-center justify-content-center d-flex"
                  >
                    <Tab eventKey="first" title="SENDER">
                      <div dangerouslySetInnerHTML={{ __html: workPageData && workPageData.sender }} />

                    </Tab>
                    <Tab eventKey="second" title="TRAVELER">
                      <div dangerouslySetInnerHTML={{ __html: workPageData && workPageData.traveler }} />

                    </Tab>
                  </Tabs>
                </Row>
              </div>
            </section>
          </main>
        </>)}
    </>
  );
}

export default Work;
